export enum Environments {
  DEV = 'DEV',
  QA = 'QA',
  PROD = 'PROD',
}
